import { useContext, useEffect, useState } from "react";
import Modal from "./components/Modal";
import StartButton from "./components/StartButton";
import { ModalContext } from "./contexts/ModalContext";
import Screens from "./Screens";

function App() {
  // const [modalOpen, , , close] = useContext(ModalContext);
  const [modalOpen, ,open , close] = useContext(ModalContext);
  const [showApp, setShowApp] = useState(true);

  useEffect(() => {
    const url: string = `${window.location.search.split("?")[1]}`;

    if (url.includes("cambiate")) {
      setShowApp(false);
    }
  }, []);

  return (
    <>
      {/* {!modalOpen && <StartButton modalOpen={modalOpen} open={open} close={close} />} */}
      {showApp && modalOpen && (
        <Modal modalOpen={modalOpen} handleClose={close}>
          <Screens />
        </Modal>
      )}
    </>
  );
}

export default App;
